import { render, staticRenderFns } from "./YAxisExtSelectorAntV.vue?vue&type=template&id=8ba867fa&scoped=true"
import script from "./YAxisExtSelectorAntV.vue?vue&type=script&lang=js"
export * from "./YAxisExtSelectorAntV.vue?vue&type=script&lang=js"
import style0 from "./YAxisExtSelectorAntV.vue?vue&type=style&index=0&id=8ba867fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba867fa",
  null
  
)

export default component.exports